var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.avatar)?_c('div',{staticClass:"SkeletonBox",style:({
      width: _vm.computedHeight,
      height: _vm.computedHeight,
      borderRadius: '50%'
    })}):_c('div',{staticClass:"SkeletonBox rounded-sm",style:({ height: _vm.height, width: _vm.computedWidth })})])}
var staticRenderFns = []

export { render, staticRenderFns }